<template>
  <form @submit.prevent="">
    <ZDialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="custom-header">
          <div class="row">
            <div class="col-md-11">
              <h4 class="modal-title">
                {{ title }}
              </h4>
            </div>
            <div class="col-md-1">
              <a href="#" class="custom-close" @click="close">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
      <template #body>
        <div class="custom-body">
          <div v-if="scheduledDate" class="row mb-3">
            <div class="col">
              <div class="custom-scheduled-highlight">
                <span class="custom-label">Date Scheduled:</span>
                <span class="ms-2">{{ scheduledDate }}</span>
              </div>
              <div class="custom-shop-message mt-2">
                The shop has requested that service be performed at this date/time.
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col">
              <label class="form-label fw-bold">Assign Technician(s)</label>
              <Multiselect
                v-model="selectedTechs"
                mode="tags"
                :options="technicians"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Select technicians..."
                label="name"
                track-by="id"
                :preselect-first="false"
                class="custom-multiselect"
                @select="choseTech"
              />
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="custom-footer">
          <div class="col">
            <button type="button" class="btn btn-light" @click="unassignAll()">UnAssign All</button>
          </div>
          <div class="col-4 custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Cancel</button>
            <button v-show="isSave" class="btn btn-danger ms-2" :disabled="isSaving" @click="save()">
              <span class="ms-2">Confirm</span>
            </button>
          </div>
        </div>
      </template>
    </ZDialog>
  </form>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { lookupStore } from '@/stores/lookup'
import { adasStore } from '@/stores/adas'
import { scheduleStore } from '@/stores/schedule'
import Multiselect from '@vueform/multiselect'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import moment from 'moment'
export default {
  name: 'DialogSchedule',
  components: {
    Multiselect,
    ZDialog
  },
  props: {
    modelValue: Object
  },
  data() {
    return {
      modalSize: 'modal-md',
      isSave: false,
      isSaving: false,
      selectedTechs: null
    }
  },
  mounted() {
    this.init()
  },
  emits: ['close', 'changed', 'saved'],
  computed: {
    ...mapState(lookupStore, ['lookups']),
    ...mapState(adasStore, ['inspectionInfo']),
    isVisible() {
      console.log('modelValue', {
        model: this.modelValue
      })
      return this.modelValue !== null
    },
    title() {
      return 'Confirm Assignment'
    },
    technicians() {
      let _techs = []
      if (this.lookups['Technician']) {
        this.lookups['Technician'].forEach((item) => {
          _techs.push({
            id: item.id,
            name: item.name,
            value: item.id
          })
        })
      }
      console.log('Techs', _techs)
      return _techs
    },
    scheduledDate() {
      let _data = null
      if (this.inspectionInfo) {
        if (this.inspectionInfo.scheduledOn) {
          let dateStr = moment(this.inspectionInfo.scheduledOn).local().format('MM/DD/YYYY')
          let timeOfDay = this.inspectionInfo.preferredTimeOfDay
          _data = timeOfDay ? `${dateStr} (${timeOfDay})` : dateStr
        }
      }
      return _data
    }
  },
  methods: {
    ...mapActions(scheduleStore, ['assignTechnician', 'unassignTech']),
    init() {
      this.isSave = false
      this.isSaving = false
      this.selectedTechs = []
    },
    close() {
      this.init()
      this.$emit('close')
    },
    cancel() {
      this.init()
      this.$emit('close')
    },
    choseTech() {
      this.isSave = true
    },
    async unassignAll() {
      await this.unassignTech({
        calibrateRequest: this.inspectionInfo.calibrateRequest,
        opportunity: this.inspectionInfo.opportunity
      })
      alert('Request has been unassigned.')
    },
    async save() {
      this.isSaving = true
      if (this.selectedTechs.length > 0) {
        for (const element of this.selectedTechs) {
          let data = {
            contact: element,
            calibrateRequest: this.inspectionInfo.calibrateRequest,
            opportunity: this.inspectionInfo.opportunity,
            schedule: null,
            bay: null,
            notes: null
          }
          await this.assignTechnician(data)
        }
      }
      this.init()
      this.$emit('saved')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-body {
  padding: 5px;
  min-height: 400px;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-right-align {
  text-align: right;
}
.custom-multiselect {
  width: 100%;
}
.custom-scheduled-highlight {
  border: 2px solid red;
  border-radius: 4px;
  padding: 8px 16px;
  display: inline-block;
  font-size: 1.1rem;
}
.custom-label {
  font-weight: 600;
}
.custom-shop-message {
  font-size: 0.95rem;
  color: #555;
  font-style: italic;
}
</style>
